import { render, staticRenderFns } from "./GroupRoleView.vue?vue&type=template&id=7123ed95"
import script from "./GroupRoleView.vue?vue&type=script&lang=js"
export * from "./GroupRoleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports